import { Component } from "@angular/core";
import { AppService } from "../app.service";
import { ActivatedRoute, Router } from "@angular/router";
import { CryptoService } from "../crypto.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";

@Component({
  selector: "app-reminders",
  standalone: false,
  templateUrl: "./reminders.component.html",
  styleUrls: ["./reminders.component.css"],
})
export class RemindersComponent {
  displayedColumns: string[] = ["reminder", "info", "frequency", "actions"];
  remlist: any = [];
  apiKey: any;
  userKey: any;
  showErrorMsg: boolean = false;
  showErrorText: any;
  status: any;
  csummery: any;
  workspaceName: any;
  txt: any;
  loading = true;

  constructor(
    public appService: AppService,
    public router: Router,
    private http: HttpClient,
    private route: ActivatedRoute
  ) {
    this.userKey = this.route.snapshot.paramMap.get("key");
  }

  ngOnInit(): void {
    this.loading = true;
    this.getConnectorSummary();
    this.getReminders();
  }

async getConnectorSummary() {
    
    try {

      let activationPayload: any = {
        routeType:"UI_SESSION"
      };
      const wsJson = this.appService.get("xdbc.workspace");

      if (wsJson !== undefined && typeof wsJson === 'string' && wsJson.trim() !== '' && wsJson !== 'undefined') {
      try {
        const ws = JSON.parse(wsJson);
        this.apiKey = ws.apiKey;
        this.status = ws.status;
      } catch (err) {
        console.error('Invalid JSON:', err);
      }
    }  

    const signatureData = await this.appService.wssign(
    activationPayload,
      this.workspaceName
    );

      if (!signatureData) {
        throw new Error("Failed to sign activation payload");
      }

      const signature = new TextDecoder().decode(signatureData);

      const response = await this.appService.wsPostRequestWithHeaders(
      activationPayload,
      "usage/connector-summary",
      this.apiKey,
      signature
    );

    if (response && response.status == "Success") {
      this.txt = response.message;
      // this.appService.addSuccessMessage(this.txt);
    }
    
    } catch (error: any) {
      this.txt = "Activation failed: " + (error.message || "Unknown error");
    }

  }

  formatTimeStamp(ts: number): string {
    const timestamp = ts * 1000;
    const date = new Date(timestamp);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  }

  async copyMessage(message: string) {
    try {
      await navigator.clipboard.writeText(message);
    } catch (err) {
      console.error("Failed to copy: ", err);
    }
  }

  async handleReminderAction(reminder: any, action: string) {
    try {
      const wsJson = this.appService.get("xdbc.workspace");

      if (wsJson !== undefined && typeof wsJson === 'string' && wsJson.trim() !== '' && wsJson !== 'undefined') {
      try {
        const ws = JSON.parse(wsJson);
        this.apiKey = ws.apiKey;
        this.workspaceName = ws.workspaceName;
      } catch (err) {
        console.error('Invalid JSON:', err);
      }
    }  

      const actionPayload = {
        userKey: this.userKey,
        transactionNumber: reminder.transactionNumber,
        action: action,
        routeType:"UI_SESSION"
      };

      const signatureData = await this.appService.wssign(
        actionPayload,
        this.workspaceName
      );

      if (!signatureData) {
        throw new Error("Failed to sign action payload");
      }

      const signature = new TextDecoder().decode(signatureData);

      const response = await this.appService.wsPostRequestWithHeaders(
        actionPayload,
        "reminder/action", // Assuming this is the endpoint
        this.apiKey,
        signature
      );

      if (response && response.status == "Success") {
        if (action === "DONE") {
          // Remove the reminder from the list if marked as done
          this.remlist.data.reminders = this.remlist.data.reminders.filter(
            (rem: any) => rem.transactionNumber !== reminder.transactionNumber
          );
          this.txt = "Reminder marked as done";
        } else if (action === "SNOOZE") {
          this.txt = "Reminder snoozed";
          // Optionally refresh the list to get updated snooze time
          // this.getReminders();
        }
        // this.appService.addSuccessMessage(this.txt);
      } else {
        throw new Error(
          response?.message || `Failed to ${action.toLowerCase()} reminder`
        );
      }
    } catch (error: any) {
      console.error(`Error in ${action.toLowerCase()} reminder:`, error);
      this.txt =
        `Failed to ${action.toLowerCase()} reminder: ` +
        (error.message || "Unknown error");
      // this.appService.addErrorMessage(this.txt);
    }
  }

  // Method to mark reminder as done
  async markAsDone(reminder: any) {
    await this.handleReminderAction(reminder, "DONE");
  }

  // Method to snooze reminder
  async snoozeReminder(reminder: any) {
    await this.handleReminderAction(reminder, "SNOOZE");
  }

  async getReminders() {
    try {
      const wsJson = this.appService.get("xdbc.workspace"); 
      
      if (wsJson !== undefined && typeof wsJson === 'string' && wsJson.trim() !== '' && wsJson !== 'undefined') {
        try {
          const ws = JSON.parse(wsJson);
          this.apiKey = ws.apiKey;
          this.status = ws.status;
          this.workspaceName = ws.workspaceName;
        } catch (err) {
          console.error('Invalid JSON:', err);
        }
      }  

      if (this.status === "ACTIVATED") {
        this.showErrorMsg = false;
      } else {
        this.showErrorMsg = true;
        this.showErrorText =
          "The selected workspace is currently inactive. Please activate it to proceed.";
      }

      let activationPayload: any = {
        routeType:"UI_SESSION"
      };
      if (this.userKey) {
        activationPayload.userKey = this.userKey;
      }

      const signatureData = await this.appService.wssign(
        activationPayload,
        this.workspaceName
      );

      if (!signatureData) {
        throw new Error("Failed to sign activation payload");
      }

      const signature = new TextDecoder().decode(signatureData);

      const response = await this.appService.wsPostRequestWithHeaders(
        activationPayload,
        "reminder/list",
        this.apiKey,
        signature
      );
      this.loading = false;
      if (response && response.status == "Success") {
        this.remlist = response;
        this.txt = response.message;
        // this.appService.addSuccessMessage(this.txt);
      } else {
        throw new Error(response?.message);
      }
    } catch (error: any) {
      // console.error("Error in submitPrivateKey:", error);
      this.txt = "Activation failed: " + (error.message || "Unknown error");
      // this.appService.addErrorMessage(
      //   "Failed to activate connector: " + (error.message || "Unknown error")
      // );
    }
  }
}
